import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "panel",
    "toggleButton",
    "sheetOverlay",
    "locationInput",
    "sheetLocationInput",
  ];

  toggle() {
    // On mobile: open the bottom sheet overlay
    if (this.hasSheetOverlayTarget) {
      this.openSheet();
    } else {
      // Fallback: simple toggle for desktop
      this.panelTarget.classList.toggle("discovery-filters--open");
      const isOpen = this.panelTarget.classList.contains(
        "discovery-filters--open"
      );
      this.toggleButtonTarget.innerHTML = isOpen
        ? '<i class="icon filter"></i> Hide Filters'
        : '<i class="icon filter"></i> Show Filters';
    }
  }

  openSheet() {
    this.sheetOverlayTarget.classList.add("discovery-filter-sheet--open");
    document.body.style.overflow = "hidden";
  }

  closeSheet() {
    this.sheetOverlayTarget.classList.remove("discovery-filter-sheet--open");
    document.body.style.overflow = "";
  }

  closeSheetOnOverlay(event) {
    // Only close if clicking the overlay background, not the sheet content
    if (event.target === this.sheetOverlayTarget) {
      this.closeSheet();
    }
  }

  applyFilters() {
    // The mobile sheet lives outside the filter form, so copy its location
    // value into the form input before submitting
    if (this.hasSheetLocationInputTarget && this.hasLocationInputTarget) {
      this.locationInputTarget.value = this.sheetLocationInputTarget.value;
    }
    const form = document.getElementById("influencer_search_form");
    if (form) {
      form.submit();
    }
    this.closeSheet();
  }
}
